export const TRIAL_CONNECTED_WORLD = 'connected_world';
